import React from "react";

export default function Map() {
  return (
    <div className="container my-3" style={{ width: "100%", height: "80vh" }}>
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3072.988929658085!2d-106.05352492432158!3d39.62745310329952!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x876a5b992a739c1b%3A0x23070399c7fc8d6e!2sSpinnaker%20Lake%20Dillon!5e0!3m2!1sen!2sin!4v1746130491184!5m2!1sen!2sin"
        width="100%"
        height="100%"
        style={{ border: 0 }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        title="Spinnaker Lake Dillon Map"
      ></iframe>
    </div>
  );
}
